<div class="row" *ngIf="onlyFormBuilder !== 'FB'">
  <div class="col-md-10 membersListMain pb-2">
    <div class="arrowIcons" *ngIf="hasHorizontalScroll">
      <i class="pi pi-caret-left" (click)="scrollLeft()"></i>
    </div>
    <div class="membersList" #scrollContainer>
      <button style="display: inline;" pButton type="button" (click)="handleCustomTabChange(null,null)"
        [ngClass]="currentIndex==null ? 'activeItem p-button-info p-button-rounded mr-2' : 'p-button-info p-button-rounded mr-2'">
       <span class="common-bene-class-for-translation">{{benefirstAndLastName}}</span> 
      </button>
      <button style="display: inline;" pButton type="button" *ngFor="let dependent of dependentsList; let i=index;"
        (click)="handleCustomTabChange(dependent,i)"
        [ngClass]="currentIndex==i ? 'activeItem p-button-info p-button-rounded mr-2 truncate-text' : 'p-button-info p-button-rounded mr-2'">
        <p class="w-100 m-0 common-bene-class-for-translation" [pTooltip]="(dependent?.fullName?.length > 14) ? dependent?.fullName: ''">
          {{dependent.fullName | truncate: 14}}</p>
        <p class="w-100 m-0 relationShip common-bene-class-for-translation">({{dependent.relationshipCode}})</p>
      </button>
    </div>
    <div class="arrowIcons" *ngIf="hasHorizontalScroll">
      <i class="pi pi-caret-right" (click)="scrollRight()"></i>
    </div>

  </div>
  <div class="col-md-2 addMembers" id="addNewMemeber">
    <p-button class="addMembers" type="button" icon="pi pi-user-plus" (click)="addMembers()">
      <span class="common-bene-class-for-translation">ADD MEMBERS</span>
    </p-button>
  </div>
</div>
<div class="row pl-3">
  <button class="back-button back-btn-white-bg pl-0 common-bene-class-for-translation" *ngIf="originPage"
    (click)="backToOriginPage()">
    <i class="fa fa-chevron-circle-left" aria-hidden="true"></i>
    Back
  </button>
</div>

<div class="row tab-container pl-2">
  <!-- Implemeting tabs  1st tabs-->

  <div class="col-2 tab-label tab-height pt-0 ">
    <div class="lbl-text align-tabs" [ngClass]="{'activeTimeLine': toggleStatus === 'myProfile'}">
      <a (click)="toggleMode('myProfile')" class="common-bene-class-for-translation">Profile</a>
    </div>
  </div>
  <!-- 2nd tab -->
  <div class="col-2 tab-label tab-height p-2" *ngIf="currentItem=='self' && onlyFormBuilder !== 'FB'">
    <div class="lbl-text align-tabs" [ngClass]="{'activeTimeLine': toggleStatus === 'myPetitions'}">
      <a (click)="toggleMode('myPetitions')" class="common-bene-class-for-translation">Petitions</a>
    </div>
  </div>
  <!-- 3rd tab -->
  <div class="col-2 tab-label tab-height p-2" *ngIf="currentItem=='self' && onlyFormBuilder !== 'FB'">
    <div class="lbl-text align-tabs" [ngClass]="{'activeTimeLine': toggleStatus === 'myLCA'}">
      <a (click)="toggleMode('myLCA')" class="common-bene-class-for-translation" id="myLcas">LCA's</a>
    </div>
  </div>
  <!-- 4th tab -->
  <div class="col-2 tab-label tab-height p-2" *ngIf="onlyFormBuilder !== 'FB'">
    <div class="lbl-text align-tabs drafttext" [ngClass]="{'activeTimeLine': toggleStatus === 'externalLinks'}">
      <a (click)="toggleMode('externalLinks')" class="common-bene-class-for-translation"> External Links</a>
    </div>
  </div>
  <!-- 5th tab -->
  <div class="col-2 tab-label tab-height p-2" *ngIf="currentUserRole !=='Beneficiary' &&  onlyFormBuilder === 'FB'">
    <div class="lbl-text align-tabs drafttext" [ngClass]="{'activeTimeLine': toggleStatus === 'jobSummary'}">
      <a [ngClass]="!showFileUploadSection ? 'disabled common-bene-class-for-translation' : 'common-bene-class-for-translation'"
        (click)="toggleMode('jobSummary')"> Employment Summary</a>
    </div>
  </div>
  <!-- 6th tab -->
  <div class="col-2 tab-label tab-height p-2" *ngIf="onlyFormBuilder !== 'FB'">
    <div class="lbl-text align-tabs drafttext" [ngClass]="{'activeTimeLine': toggleStatus === 'cloudstorage'}">
      <a (click)="toggleMode('cloudstorage')" class="common-bene-class-for-translation"> Cloud Storage</a>
      <!-- <mat-icon>add_to_drive</mat-icon> -->
    </div>
  </div>
  <!-- 7th tab -->
  <div class="col-2 tab-label tab-height p-2" *ngIf="currentUserRole !=='Beneficiary' &&  onlyFormBuilder !== 'FB'">
    <div class="lbl-text align-tabs drafttext" [ngClass]="{'activeTimeLine': toggleStatus === 'interactionLogs'}">
      <a (click)="toggleMode('interactionLogs')" class="common-bene-class-for-translation"> Interaction Logs</a>
      <!-- <mat-icon>add_to_drive</mat-icon> -->
    </div>
  </div>
</div>

<div *ngIf="toggleStatus === 'myProfile'" class="pt-2">
  <div class="row mt-2">
    <div class="col-2 pr-0">
      <p-accordion styleClass="mainTabStyle" (onOpen)="onTabOpen($event.index, $event.originalEvent.target.id)"
        [(activeIndex)]="activeRightTabIndex">
        <!-- <p-accordionTab> 
          <p-header class="tab-styles common-bene-class-for-translation">
            QUICK START
          </p-header>
        </p-accordionTab> -->
        <p-accordionTab>
          <p-header class="tab-styles upper-case common-bene-class-for-translation" id="PERSONALINFO">
            PERSONAL INFO
          </p-header>
        </p-accordionTab>
        <p-accordionTab header="EDUCATION">
          <p-header class="tab-styles upper-case common-bene-class-for-translation" id="EDUCATION">
            EDUCATION
          </p-header>
        </p-accordionTab>
        <p-accordionTab header="WORK EXPERIENCE">
          <p-header class="tab-styles upper-case common-bene-class-for-translation" id="WORK-EXPERIENCE">
            WORK EXPERIENCE
          </p-header>
        </p-accordionTab>
        <p-accordionTab header="IMMIGRATION">
          <p-header class="tab-styles upper-case common-bene-class-for-translation" id="IMMIGRATION">
            IMMIGRATION
          </p-header>
        </p-accordionTab>
        <p-accordionTab header="DOCUMENTS LIST">
          <p-header class="tab-styles upper-case common-bene-class-for-translation" id="DOCUMENTS-LIST">
            DOCUMENTS LIST
          </p-header>
        </p-accordionTab>
        <p-accordionTab header="DOCUMENTS EXPIRATIONS">
          <p-header class="tab-styles upper-case tab-styles common-bene-class-for-translation" id="DOCUMENTS-EXPIRATIONS">
            DOCUMENTS EXPIRATIONS
          </p-header>
        </p-accordionTab>
        <p-accordionTab header="E-CONSENT" *ngIf="currentUserRole == 'Attorney'">
          <p-header class="tab-styles upper-case common-bene-class-for-translation" id="eConsent">
            E-CONSENT
          </p-header>
        </p-accordionTab>
      </p-accordion>
    </div>
    <div class="col">
      <mat-card>
        <div class="row">
          <div class="ml-auto help-video-holder">
            <app-help-video-overlay #helpVideoComponent></app-help-video-overlay>
          </div>
        </div>
        <ng-container *ngIf="isQuickStart">
          <app-ocr-converter [detailsAbout]="selectedDetailAbout"></app-ocr-converter>
        </ng-container>
        <ng-container *ngIf="isSelf">
          <div id="profileContainer">
            <p-tabView *ngIf="isDependent || isFamily" styleClass="mainTabStyle" [ngClass]="{'family': isFamily}"
              [(activeIndex)]="activeIndex" (onChange)="handleTabChange($event)">
              <p-tabPanel [header]="item.name" *ngFor="let item of dependentItems; let i = index" [selected]="i == 0">
                <div class="subtab-container" *ngIf="item.subTabsList">
                  <p-tabView styleClass="subTabStyle" [(activeIndex)]="activeSubIndex"
                    (onChange)="handleSubTabChange($event,item)">

                    <p-tabPanel *ngFor="let subTab of item.subTabsList; let j = index" [header]="subTab.header">

                    </p-tabPanel>
                  </p-tabView>
                  <button class="addDependentBtn last" [ngClass]="{'first': item.subTabsList.length === 0}"
                    [disabled]="item.subTabsList.length > 0 && item.subTabsList[item.subTabsList.length - 1].id == 0"
                    (click)="addSubTabs(item)">Add {{item.name}}</button>
                </div>
              </p-tabPanel>
            </p-tabView>
            <p-accordion class="mainProfileContent">
              <p-accordionTab class="personal-details-header" [selected]="profileUpdate">

                <p-header> <span class="common-bene-class-for-translation" id="personalDetails1">Personal
                    Details</span></p-header>

                <lib-generic-beneficiary-personal-details-library (profileEditStatus)="onEditClicked($event)"
                  (personalDetails)="personalDetails($event)" [detailsAbout]="selectedDetailAbout"
                  (hasPassportChange)="onHasPassportChange($event)" [editMode]="personalDetailsEdit"
                  [isShowVerify]="false" [customQuestionsDisplay]="customQuestionnaieDisplay" [passportShow]="false">
                </lib-generic-beneficiary-personal-details-library>
                <mat-card>
                  <div class="mt-2 mb-2 mr-2 ml-2 row">
                    <p *ngIf="!viewMode" class="lbl-text-2 common-bene-class-for-translation" id="AddPassportPhotocopy">
                      Add passport photocopy</p>
                    <app-file-upload style="width: 100%;" [configurations]="fileUploadConfigurations">
                    </app-file-upload>
                  </div>
                </mat-card>
              </p-accordionTab>
              <div *ngIf="showFileUploadSection">
                <div *ngIf="selectedDetailAbout?.showDetailFor == 'self'">
                  <div *ngFor="let ques of customQuestionnaieDisplay?.customSectionList">
                    <div class="customSections" *ngFor="let item of ques?.stakeHoldersSelected">
                      <p-accordionTab *ngIf="(item?.key == 'QTPROFILEBEN') && item?.selected == true"
                        [header]="ques.name" [selected]="false" [hidden]="ques?.isBenHidden">
                        <app-custom-questions [isNewPortion]="true" [viewQuestions]="false" [loadedIn]="ques?.name"
                          [beneficiaryId]="beneficiaryId" [isSection]="true" [familyId]="currentFamilyId"
                          (refreshList)="onRefreshPage($event)"></app-custom-questions>
                      </p-accordionTab>
                    </div>
                  </div>
                </div>
                <div *ngIf="selectedDetailAbout?.showDetailFor !== 'self' && currentFamilyId">
                  <div *ngFor="let ques of customQuestionnaieDisplay?.customSectionList">
                    <div class="customSections" *ngFor="let item of ques?.stakeHoldersSelected">
                      <p-accordionTab
                        *ngIf="(selectedDetailAbout?.dependentType.code == item?.key) && item?.selected == true"
                        [header]="ques.name" [selected]="false" [hidden]="ques?.isBenHidden">
                        <app-custom-questions [isNewPortion]="true" [viewQuestions]="false" [loadedIn]="ques?.name"
                          [beneficiaryId]="beneficiaryId" [isSection]="true" [familyId]="currentFamilyId"
                          (refreshList)="onRefreshPage($event)"></app-custom-questions>
                      </p-accordionTab>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-3" *ngIf="(!showFileUploadSection && selectedDetailAbout?.showDetailFor == 'self')">
                <mat-card>
                  <mat-card-header class="customHeader">
                    <mat-card-title>
                      <p class="common-bene-class-for-translation">Personal details need to be completed & saved, to
                        continue with the addition of
                        custom section details</p>
                    </mat-card-title>
                  </mat-card-header>
                </mat-card>
              </div>
              <div class="mt-3" *ngIf="(!currentFamilyId && selectedDetailAbout?.showDetailFor !== 'self')">
                <mat-card>
                  <mat-card-header class="customHeader">
                    <mat-card-title>
                      <p class="common-bene-class-for-translation">Personal details need to be completed & saved, to
                        continue with the addition of
                        custom section details</p>
                    </mat-card-title>
                  </mat-card-header>
                </mat-card>
              </div>

            </p-accordion>
          </div>
        </ng-container>

        <ng-container *ngIf="isEducation">
          <lib-generic-beneficiary-education [isBeneficiaryProfile]="true"></lib-generic-beneficiary-education>
        </ng-container>
        <ng-container *ngIf="isWorkExperience">
          <h5 class="header-tab common-bene-class-for-translation" id="word_experience_1">Work Experience</h5>
          <lib-generic-beneficiary-work-experience [familyId]="familyId"
            [showLifeStoryTimeLineSection]="showLifeStoryTimeLineSection"
            [isWizard]="false"></lib-generic-beneficiary-work-experience>
          <!-- <app-work-experience></app-work-experience> -->
        </ng-container>
        <ng-container *ngIf="isImmigration">
          <!-- <h5 class="header-tab common-bene-class-for-translation">Immigration</h5> -->
          <!-- <beneficiary-immigration></beneficiary-immigration> -->
          <lib-generic-beneficiary-immigration-details-library></lib-generic-beneficiary-immigration-details-library>
        </ng-container>
        <ng-container *ngIf="isDocuments">
          <app-document-list (removeElement)="deleteDocumentHandler($event)"></app-document-list>
        </ng-container>
        <ng-container *ngIf="isDocumentsExpirations">
          <app-expiry-alert-documents></app-expiry-alert-documents>
        </ng-container>
        <ng-container *ngIf="isEConsent">
          <app-e-consent></app-e-consent>
        </ng-container>
      </mat-card>
    </div>
  </div>

</div>

<div *ngIf="toggleStatus === 'myPetitions'" class="pt-2">
  <app-manage-petition-bene [individualId]="beneficiaryId" [isFromListingPage]="true"></app-manage-petition-bene>
</div>

<div *ngIf="toggleStatus === 'myLCA'" class="pt-2">
  <app-beneficiary-lca></app-beneficiary-lca>
</div>

<div *ngIf="toggleStatus === 'externalLinks'" class="pt-2 pr-3">
  <lib-external-links
    [inputData]="{fromBenProfile:true,fromTask: false, externalBeneficiaryId:externalBeneficiaryId}"></lib-external-links>
</div>

<div *ngIf="toggleStatus === 'jobSummary'" class="pt-2">
  <div class="row mt-2">
    <div class="col-9">
      <p class="lead common-bene-class-for-translation">Summary</p>
      <!--IM-3898 --->
    </div>
    <div class="col-3">
      <p class="lead">{{userTimeNow}}</p>
    </div>
  </div>

  <div class="row mt-2">
    <div class="col-3">
      <p-accordion styleClass="mainTabStyle" (onOpen)="onTabOpen($event.index, $event.originalEvent.target.innerText)"
        [(activeIndex)]="activeRightTabIndex">
        <p-accordionTab>
          <p-header class="tab-styles">
            Summary
          </p-header>
          <div class="row mt-2">
            <div class="col">
              <mat-card class="row profile-image-card">
                <ng-container *ngIf="!viewMode; else viewOnly">
                  <div class="text-center imageBox">
                    <img [src]="profilePic?profilePic:'../../../../../assets/cameraIcon.png'" class="rounded-circle"
                      (click)="uploadProfile()" />
                    <span class="material-icons edit-img-icon common-bene-class-for-translation"
                      (click)="uploadProfile()">edit</span>
                  </div>
                </ng-container>
                <ng-template #viewOnly>
                  <div class="text-center imageBox">
                    <img [src]="profilePic?profilePic:'../../../../../assets/cameraIcon.png'" class="rounded-circle" />
                    <span class="material-icons edit-img-icon common-bene-class-for-translation"
                      (click)="uploadProfile()">edit</span>
                  </div>
                </ng-template>
              </mat-card>
              <mat-card>
                <ng-container>
                  <div class="emp-details">
                    <h5>{{employeeJobDetails?.beneficaryFAndLName}}</h5>
                    <p> {{employeeJobDetails?.employeeId}}</p>
                    <h6>{{employeeJobDetails?.position ? employeeJobDetails?.position : "--"}}</h6>
                  </div>
                </ng-container>
              </mat-card>
            </div>
          </div>
        </p-accordionTab>

        <div class="accordion-header" (click)="toggleFinancials()">
          <button class="accordion-button" [class.expanded]="isFinancialsOpen" type="button">
            <span class="accordion-text common-bene-class-for-translation">Financials</span>
            <i class="fas" [ngClass]="{'fa-chevron-up': isFinancialsOpen, 'fa-chevron-down': !isFinancialsOpen}"></i>
          </button>
        </div>

        <p-accordionTab class="bankdetails" (click)="setAccordionContentStyle('none')" header="BANK DETAILS"
          *ngIf="isFinancialsOpen">
          <p-header class="tab-styles common-bene-class-for-translation">
            BANK DETAILS
          </p-header>
        </p-accordionTab>
        <p-accordionTab class="w4details" (click)="setAccordionContentStyle('none')" header="W4 DETAILS(OPTIONAL)"
          *ngIf="isFinancialsOpen">
          <p-header class="tab-styles common-bene-class-for-translation">
            W4 DETAILS(OPTIONAL)
          </p-header>
        </p-accordionTab>
        <p-accordionTab class="form16details" (click)="setAccordionContentStyle('none')" header="Form 16"
          *ngIf="isFinancialsOpen">
          <p-header class="tab-styles common-bene-class-for-translation">
            STATUTORY DETAILS(OPTIONAL)
          </p-header>
        </p-accordionTab>
        <!-- <p-accordionTab class="my_payslips" (click)="setAccordionContentStyle('none')" header="My Payslips" *ngIf="isFinancialsOpen">
                <p-header class="tab-styles">
                  My Payslips
                </p-header>
              </p-accordionTab> -->

        <!-- </div> -->

      </p-accordion>
    </div>
    <div class="col">
      <mat-card>
        <div class="row">
          <div class="ml-auto help-video-holder">
            <app-help-video-overlay #helpVideoComponent></app-help-video-overlay>
          </div>
        </div>
        <ng-container *ngIf="isJobDetails">
          <div id="profileContainer">
            <p-accordion>
              <p-accordionTab header="Employee Job Details" [selected]="profileUpdate">
                <app-employee-job-details></app-employee-job-details>
              </p-accordionTab>
            </p-accordion>
          </div>
        </ng-container>
        <ng-container *ngIf="isBankDetails">
          <div id="profileContainer">
            <p-accordion>
              <p-accordionTab header="Banks Details (Primary)"
                [selected]="profileUpdate">
                <app-bank-details [detailsAbout]="selectedDetailAbout" [containerId]="0"
                  (profileEditStatus)="onEditClicked($event)"
                  (removeElement)="deleteBankDocumentHandler($event)"></app-bank-details>
              </p-accordionTab>
              <p-accordionTab header="Banks Details" [selected]="profileUpdate">
                <app-bank-details [detailsAbout]="selectedDetailAbout" [containerId]="1"
                  (profileEditStatus)="onEditClicked($event)"
                  (removeElement)="deleteBankDocumentHandler($event)"></app-bank-details>
              </p-accordionTab>
            </p-accordion>
          </div>
        </ng-container>
        <ng-container *ngIf="isW4Details">
          <div id="profileContainer">
            <p-accordion>
              <p-accordionTab header="W4 Details" [selected]="profileUpdate">
                <app-w4-details [detailsAbout]="selectedDetailAbout" (profileEditStatus)="onEditClicked($event)"
                  (removeElement)="deleteW4DocumentHandler($event)"></app-w4-details>
              </p-accordionTab>
            </p-accordion>
          </div>
        </ng-container>
        <ng-container *ngIf="isForm16Details">
          <div id="profileContainer">
            <p-accordion>
              <p-accordionTab header="Statutory Details" [selected]="profileUpdate">
                <app-form16-details [detailsAbout]="selectedDetailAbout" (profileEditStatus)="onEditClicked($event)"
                  (removeElement)="deleteForm16DocumentHandler($event)"></app-form16-details>
              </p-accordionTab>
            </p-accordion>
          </div>
        </ng-container>
        <!-- <ng-container *ngIf="isForm16Details">
          <div id="profileContainer">
            <p-accordion>
              <p-accordionTab header="Statutory Details" class="personal-details-header" [selected]="profileUpdate">
                <app-form16-details [detailsAbout]="selectedDetailAbout" (profileEditStatus)="onEditClicked($event)"
                (removeElement)="deleteForm16DocumentHandler($event)"></app-form16-details>
              </p-accordionTab>
            </p-accordion>
          </div>
        </ng-container> -->
        <ng-container *ngIf="isMyPayslipsDetails">
          <div id="profileContainer">
            <p-accordion>
              <p-accordionTab header="PAYSLIPS" [selected]="profileUpdate">
                <app-my-payslips></app-my-payslips>
              </p-accordionTab>
            </p-accordion>
          </div>
        </ng-container>
        <!-- <ng-container *ngIf="isDocuments">
          <app-document-list (removeElement)="deleteDocumentHandler($event)"></app-document-list>
        </ng-container> -->
      </mat-card>
    </div>
  </div>
</div>

<div *ngIf="toggleStatus === 'cloudstorage'" class="pt-2 pr-3 cloud-storage-main">
  <!-- ///////////////////// -->
  <div class="row margin-top-bottom-15 bg-white">
    <div class="col-2 px-0 set-accordion" style="min-height: 60vh !important">
      <p-accordion #accord [multiple]="true" expandIcon="pi pi-plus" collapseIcon="pi pi-minus">
        <p-accordionTab [selected]="true">
          <ng-template pTemplate="header common-bene-class-for-translation">Manage&nbsp;Storage</ng-template>
          <ng-template pTemplate="content" class="border-top-0 border-left-0 border-right-0 border-bottom-1">
            <div class="d-flex flex-column justify-content-start align-items-start">
              <button class="btn btn-link px-1 common-bene-class-for-translation" type="button" [disabled]="isDropBox"
                (click)="showDropbox()">
                Integrate Dropbox
              </button>
            </div>
            <div class="d-flex flex-column justify-content-start align-items-start">
              <button class="btn btn-link px-1 common-bene-class-for-translation" type="button"
                [disabled]="isGoogleDrive" (click)="showGoogleDrive()">
                Integrate Google Drive
              </button>
            </div>
          </ng-template>
        </p-accordionTab>
      </p-accordion>
    </div>
    <div class="col-10 px-0" style="min-height: 60vh !important">
      <div *ngIf="isDropBox" class="pt-2 pr-3 pl-3">
        <app-drop-box></app-drop-box>
      </div>
      <div *ngIf="isGoogleDrive" class="pt-2 pr-3 pl-3">
        <div class="row">
          <div class="col-md-7">
            <div class="mat-title titleColor font-weight-bold mb-1 common-bene-class-for-translation">Manage Your Google
              Drive Documents</div>
            <div class="mat-subheading-1 titleColor mb-1 common-bene-class-for-translation">Manage existing Google Drive
              documents</div>
          </div>
          <div class="col-md-5 d-flex justify-content-end">
            <!-- <button (click)="listFiles()">Google Files</button> -->
            <button (click)="handleAuthClick()" disabled
              class="im-btn ml-3 button_whitebg im-btn-with-icon im-btn-outline-primary im-btn-md">
              <i class="fa fa-plus im-drop-icon pt-1 common-bene-class-for-translation"></i> Add Google Drive
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ///////////////////// -->
</div>

<div *ngIf="toggleStatus === 'interactionLogs'" class="pt-2 pr-3">
  <div class="tab-box">
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
      <mat-tab label="Notes">
        <app-beneficiary-add-notes></app-beneficiary-add-notes>
      </mat-tab>
      <mat-tab label="Data and Document Requests">
        <!-- <app-data-log [dataLogChanges]="dataLogStatus" class="w-100"></app-data-log> -->
      </mat-tab>
    </mat-tab-group>
  </div>
</div>

<p-confirmDialog header="Confirm Reset" key="docchecklistreset"></p-confirmDialog>

<p-dialog [styleClass]="'doc-checklist-modal'" [(visible)]="displayDocumentPanel" [modal]="true" [responsive]="true"
  [style]="{width: '600px', minWidth: '200px'}" [minY]="70" [maximizable]="false">
  <ng-template pTemplate="header">
    <div>
      <div class="row">
        <div class="col-12 px-0">
          <h5 class="text-secondary mb-0 common-bene-class-for-translation">Add Family Member</h5>
        </div>
      </div>
    </div>
  </ng-template>
  <hr class="mt-0" />

  <div class="p-fluid p-formgrid p-grid px-3 pt-2">

    <div class="p-col">
      <label class="label-cls common-bene-class-for-translation">Family member's relationship with beneficiary</label>
      <p-dropdown class="w-100 common-bene-class-for-translation" panelStyleClass="dc-dropdown-panel" appendTo="body"
        required placeholder="Select Relationship" optionLabel="name" optionValue="code"
        [options]="familyRelTypeArr"></p-dropdown>
    </div>

  </div>

  <div class="p-fluid p-formgrid p-grid px-3 pt-2">

    <div class="p-col-6">
      <label class="label-cls common-bene-class-for-translation"> First Name </label>
      <input class="im-input mw-100" type="text" pInputText placeholder="Enter" />
    </div>
    <div class="p-col-6">
      <label class="label-cls common-bene-class-for-translation"> Last Name </label>
      <input class="im-input mw-100" type="text" pInputText placeholder="Enter" />
    </div>

  </div>

  <div class="p-fluid p-formgrid p-grid px-3 pt-2">
    <div class="p-col-6">
      <p-checkbox binary="true" label="Primary Applicant" class="common-bene-class-for-translation">Primary
        Applicant</p-checkbox>
    </div>

  </div>
  <hr class="mt-2" />
  <p-footer>
    <button type="button" class="p-button-secondary mr-3 cancel-btn p-button-raised common-bene-class-for-translation"
      pButton label="I will do it later" (click)="displayDocumentPanel = false"></button>
    <button type="button" pButton label="Add" class=" common-bene-class-for-translation"></button>
  </p-footer>
</p-dialog>